export default {
  'menu.login': "登录",
  'menu.appraisal': "鉴定管理",
  'menu.appraisal.category': '分类管理',
  'menu.appraisal.identity': "鉴定管理",
  'menu.appraisal.identityHistory': "鉴定订单",
  'menu.appraisal.guide': "引导页管理",
  'menu.appraisal.reservation': "预约价格管理",
  'menu.appraisal.brand': "品牌预约管理",
  'menu.userManager': "用户管理",
  'menu.userManager.list': "用户列表",
  'menu.userManager.transaction': "交易明细",
  'menu.userManager.appoint': "动态管理",
  'menu.userManager.auth': "认证管理",
  'menu.userManager.address': "地址管理",
  'menu.userManager.comment': "社区评论",
  'menu.userManager.withdraw': "提现管理",
  'menu.userManager.appraiser': "鉴定师列表",

  'menu.community': "社区管理",
  'menu.community.topic': "话题列表",
  'menu.mall': "商城管理",
  'menu.mall.product': "商品列表",
  'menu.mall.productManager': "商品管理",
  'menu.mall.order': "订单列表",
  'menu.mall.orderCommenet': "订单评价",
  'menu.mall.orderManager': "订单管理",
  'menu.mall.productCategory': "商品分类",
  'menu.mall.coupon': "优惠券管理",
  'menu.mall.couponRedemption': "优惠券领取记录",
  'menu.mall.couponUse': "优惠券使用记录",
  'menu.system': "系统管理",
  "menu.system.manager": "管理员列表",
  "menu.system.role": "角色列表",
  "menu.system.permissionLog": "操作日志",

};
